import React from 'react';
import { SEO } from '../..';
import { Banner, Events, History, SafetyNorms } from '../../home';
import { Layout } from '../../layout';

export default function Home() {
  return (
    <Layout>
      <SEO title="Sociedad Venezolana de Radiología e Imagenología Dentomaxilofacial" />
      <Banner />
      <SafetyNorms />
      <Events />
      <History />
    </Layout>
  );
}
